import React, { useEffect, useState, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import UploadAndListingComponent from "../../Components/UploadAndListingComponent/UploadAndListingComponent";
import {
  Apiurl,
  GetLocalStorageParsed,
  parseData,
  stringifyData,
} from "../utils/page";
import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader/Loader";

const VendorUploadProduct = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");
  const [bannerDataImage, setBannerDataImage] = useState();
  const [images, setImages] = useState([]); // Store uploaded images
  const [editImages, setEditImages] = useState([]); // Store uploaded images
  const [oldImages, setOldImages] = useState([]); // Store uploaded images
  console.log(oldImages, "oldImagesoldImages");

  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [selectedEditImageIndex, setSelectedEditImageIndex] = useState(null);
  const [vendorProduct, setVendorProduct] = useState();
  const [vendorFilter, setVendorFilter] = useState();
  const cropperRefs = useRef([]); // Array of cropper refs for all images
  const [loading, setLoading] = useState("");
  const [changeBannerModal, setChangeBannerModal] = useState(false);
  const [pickupLocationModal, setPickupLocationModal] = useState(false);
  const [address, setAddress] = useState({
    locality: "",
    areaAndStreet: "",
    city: "",
    state: "",
    landmark: "",
    phoneNumber: "",
    pinCode: "",
  });
  const [errorMessagePickup, setErrorMessagePickup] = useState({
    locality: "",
    areaAndStreet: "",
    city: "",
    state: "",
    landmark: "",
    phoneNumber: "",
    pinCode: "",
  });
  const [pickupLocationData, setPickupLocationData] = useState([]);

  const [changeData, setChangeData] = useState({
    BannerId: "",
    ProductId: "",
  });

  const [editData, setEditData] = useState({
    Id: "",
    BannerIds: "",
    ProductName: "",
    Mrp: "",
    DealPrice: "",
    BrandName: "",
    EntryDate: "",
    FromPublishDate: "",
    ToPublishDate: "",
    ProductExpiringTime: "",
    Quantity: "",
    IsProductInOffer: "",
    ProductDescription: "",
    RecommendedBid: "",
    IsPublish: "",
    Images: "",
    DeliveryCharges: "",
    DeliveryChargesId: "",
  });
  const [editModal, setEditModal] = useState(false);
  const [relaunchModal, setRelaunchModal] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setPageNumber(0);
    setNumberofRecordSelected(10);
  }, []);

  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [deliveryCharge, setDeliveryCharges] = useState();
  const [formData, setFormData] = useState({
    BannerIds: "",
    ProductName: "",
    Mrp: "",
    DealPrice: "",
    BrandName: "",
    EntryDate: "",
    FromPublishDate: "",
    ToPublishDate: "",
    ProductExpiringTime: "",
    Quantity: "",
    IsProductInOffer: "",
    ProductDescription: "",
    RecommendedBid: "",
    DeliveryCharges: "",
    CategoryId: "",
    Keywords: [],
  });
  const [relaunchData, setRelaunchData] = useState({
    BannerIds: "",
    ProductName: "",
    ProductDescription: "",
    RecommendedBid: "",
    Mrp: "",
    BrandName: "",
    IsProductInOffer: "",
    IsRelauchForPreviousUsers: "",
    DealPrice: "",
    Quantity: "",
    RecommendedBid: "",
    FromPublishDate: "",
    ToPublishDate: "",
    ProductExpiringTime: "",
    Keywords: [],
  });
  const [categoriesData, setcategoriesData] = useState();

  const [errorMessageRelaunch, setErrorMessageRelaunch] = useState({
    Mrp: "",
    BrandName: "",
    IsProductInOffer: "",
    IsRelauchForPreviousUsers: "",
    DealPrice: "",
    Quantity: "",
    RecommendedBid: "",
    FromPublishDate: "",
    ToPublishDate: "",
    ProductExpiringTime: "",
  });

  const [errorMessage, setErrorMessage] = useState({
    BannerIds: "",
    ProductName: "",
    Mrp: "",
    BrandName: "",
    FromPublishDate: "",
    ToPublishDate: "",
    ProductExpiringTime: "",
    Quantity: "",
    IsProductInOffer: "",
    ProductDescription: "",
    Images: "",
    Keywords: [],

    CategoryId: "",
  });
  console.log(errorMessage, "errorMessageasjsjas");
  const [editErrorMessage, setEditErrorMessage] = useState({
    BannerIds: "",
    ProductName: "",
    Mrp: "",
    BrandName: "",
    FromPublishDate: "",
    ToPublishDate: "",
    ProductExpiringTime: "",
    Quantity: "",
    IsProductInOffer: "",
    ProductDescription: "",
    IsPublish: "",
    Images: "",
    Keywords: [],
  });
  const [croppedImages, setCroppedImages] = useState([]);

  const GetBannerData = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Banner/GetAccordingToVendor`,
    };
    axios(option)
      .then((e) => {
        setBannerDataImage(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };
  const GetDeliveryCharges = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/DeliveryCharges/GetDeliveryCharges`,
    };
    axios(option)
      .then((e) => {
        setDeliveryCharges(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };
  const [totalRecord, setTotalRecord] = useState();
  const [numberOfRecordSelected, setNumberofRecordSelected] = useState();
  const [pageNumber, setPageNumber] = useState(0);

  // const GetVendorProduct = () => {
  //   const option = {
  //     method: "POST",
  //     headers: {
  //       accept: "*/*",
  //       Authorization: `Bearer ${loginToken || " "}`,
  //     },
  //     url: `${Apiurl()}/api/Product/GetAllProductsOfVendorByPageAndSearch`,
  //   };
  //   axios(option)
  //     .then((e) => {
  //       setTotalRecord(e?.data?.totalRecords);

  //       setVendorProduct(parseData(e?.data?.result));
  //       setVendorFilter(parseData(e?.data?.result));
  //       setLoading("");
  //     })
  //     .catch((error) => {});
  // };
  const GetVendorProduct = (e, pagination, selected) => {
    setLoading("vendor");
    const data = {
      text: "",
      pageNumber: pagination === "pag" ? e : 1 || 1,
      pageSize: e === "All" ? 0 : selected ? selected : numberOfRecordSelected,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Product/GetAllProductsOfVendorByPageAndSearch`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.totalRecords < 10) {
          setNumberofRecordSelected(10);
          setPageNumber(0);
        }
        if (e?.data?.status === "OK") {
          setTotalRecord(e?.data?.totalRecords);

          setVendorProduct(parseData(e?.data?.result));
          setVendorFilter(parseData(e?.data?.result));
          setLoading("");
        }
      })
      .catch((error) => {});
    // }
  };
  const GetPickupLocation = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      url: `${Apiurl()}/api/Vendor/GetLocationsByVendorProduct`,
    };
    axios(option)
      .then((e) => {
        setPickupLocationData(parseData(e?.data?.result));
      })
      .catch((error) => {});
  };
  const handleGetCategory = () => {
    const option = {
      method: "Get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken}`,
      },
      url: `${Apiurl()}/api/Product/GetAllCategories`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e.data.result);
        const sortedData = data.sort((a, b) =>
          a.CatgeoryName.localeCompare(b.CatgeoryName)
        );
        setcategoriesData(sortedData);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    GetBannerData();
    GetVendorProduct();
    GetDeliveryCharges();
    GetPickupLocation();
    handleGetCategory();
  }, []);
  // Handle file uploads
  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);

    const imageURLs = files.map((file) => URL.createObjectURL(file));
    setImages((prevImages) => [...prevImages, ...imageURLs]);
    if (files?.length == 1) {
      setSelectedImageIndex(0);
    }
    setErrorMessage({
      ...errorMessage,
      Images: "",
    });
  };
  const handleEditImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const imageURLs = files.map((file) => URL.createObjectURL(file));
    if (files?.length == 1 && !oldImages?.length) {
      setSelectedEditImageIndex(0);
    }
    setEditImages((prevImages) => [...prevImages, ...imageURLs]);
    setEditErrorMessage({
      ...editErrorMessage,
      Images: "",
    });
  };

  const validations = () => {
    const errors = {};
    if (!formData?.BannerIds) {
      errors.BannerIds = "Please select atleast 1 banner";
    }
    if (!formData?.ProductName || formData?.ProductName?.trim() === "") {
      errors.ProductName = "Product Name Is Required";
    }
    if (!formData?.CategoryId) {
      errors.CategoryId = "Product Category Is Required";
    }
    if (!formData?.Mrp || formData?.Mrp?.trim() === "") {
      errors.Mrp = "Mrp Is Required";
    }
    if (!formData?.BrandName || formData?.BrandName?.trim() === "") {
      errors.BrandName = "Brand Name Is Required";
    }
    if (!formData?.FromPublishDate) {
      errors.FromPublishDate = "From Publish Date Is Required";
    }
    if (!formData?.ToPublishDate) {
      errors.ToPublishDate = "To Publish Date Is Required";
    }
    if (!formData?.ProductExpiringTime) {
      errors.ProductExpiringTime = "Expiring Time of Item Is Required";
    }
    if (!formData?.Quantity || formData?.Quantity?.trim() === "") {
      errors.Quantity = "Quantity Is Required";
    }
    if (formData?.Quantity == 0) {
      errors.Quantity = "Quantity Should be Greater than 0";
    }
    if (!formData?.IsProductInOffer) {
      errors.IsProductInOffer = "Product Options is Required";
    }
    if (formData?.IsProductInOffer == "bid" && formData?.RecommendedBid == "") {
      errors.RecommendedBid = "Please enter Recommended Bid Point ";
    }
    if (formData?.IsProductInOffer == "bid" && formData?.RecommendedBid == 0) {
      errors.RecommendedBid = "Recommended Points Should be Greater than 0  ";
    }

    if (
      !formData?.ProductDescription ||
      formData?.ProductDescription?.trim() === ""
    ) {
      errors.ProductDescription = "Product Description is Required";
    }
    if (!images?.length) {
      errors.Images = "Please Upload Image";
    }

    // If there are errors, set them and return false
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      return false;
    }

    // If no errors, clear the error messages and return true
    setErrorMessage({
      ProductName: "",
      Mrp: "",
      BrandName: "",
      FromPublishDate: "",
      ToPublishDate: "",
      ProductExpiringTime: "",
      Quantity: "",
      IsProductInOffer: "",
      ProductDescription: "",
      Keywords: [],
    });
    return true;
  };
  const editValidations = () => {
    const errors = {};
    if (!editData?.BannerIds) {
      errors.BannerIds = "Please select atleast 1 banner";
    }
    if (!editData?.ProductName || editData?.ProductName?.trim() === "") {
      errors.ProductName = "Product Name Is Required";
    }
    if (!editData?.Mrp) {
      errors.Mrp = "Mrp Is Required";
    }
    if (!editData?.BrandName || editData?.BrandName?.trim() === "") {
      errors.BrandName = "Brand Name Is Required";
    }
    if (editData?.IsProductInOffer == "bid" && editData?.RecommendedBid == "") {
      errors.RecommendedBid = "Please enter Recommended Bid Point ";
    }
    if (editData?.IsProductInOffer == "bid" && editData?.RecommendedBid == 0) {
      errors.RecommendedBid = "Recommended Points Should be Greater than 0  ";
    }
    if (editData?.IsProductInOffer == "buy" && editData?.DealPrice == "") {
      errors.DealPrice = "Please enter Deal Price ";
    }

    if (!editData?.FromPublishDate) {
      errors.FromPublishDate = "From Publish Date Is Required";
    }
    if (!editData?.ToPublishDate) {
      errors.ToPublishDate = "To Publish Date Is Required";
    }
    if (!editData?.ProductExpiringTime) {
      errors.ProductExpiringTime = "Expiring Time of Item Is Required";
    }
    if (!editData?.Quantity) {
      errors.Quantity = "Quantity Is Required";
    }
    if (editData?.Quantity == 0) {
      errors.Quantity = "Quantity Should be Greater than 0";
    }
    if (!editData?.IsProductInOffer) {
      errors.IsProductInOffer = "Product Options is Required";
    }
    // if (!editData?.Keywords || editData?.Keywords?.trim() === "") {
    //   errors.Keywords = "Keywords is Required";
    // }
    if (
      !editData?.ProductDescription ||
      editData?.ProductDescription?.trim() === ""
    ) {
      errors.ProductDescription = "Product Description is Required";
    }
    // if (!editImages?.length) {
    //   errors.Images = "Please Upload Image";
    // }
    // If there are errors, set them and return false
    if (Object.keys(errors).length > 0) {
      setEditErrorMessage(errors);
      return false;
    }

    // If no errors, clear the error messages and return true
    setEditErrorMessage({
      ProductName: "",
      Mrp: " ",
      BrandName: "",
      FromPublishDate: "",
      ToPublishDate: "",
      ProductExpiringTime: "",
      Quantity: "",
      IsProductInOffer: "",
      ProductDescription: "",
      Keywords: [],
    });
    return true;
  };
  const handleCropAndSave = () => {
    if (!validations()) return;
    setLoading("add");
    // const croppedImages = cropperRefs.current.map((cropper) => {
    //   if (cropper && cropper.getCroppedCanvas) {
    //     return cropper.getCroppedCanvas().toDataURL("image/jpeg"); // Get cropped data as base64
    //   }
    //   return null;
    // });

    // Update the ImageUrl array
    const updatedImageUrlArray = croppedImages?.map((croppedImage, index) => ({
      Images: croppedImage.replace(/^data:image\/[a-zA-Z]+;base64,/, ""),
      Name: null,
      ImgList: null,
      Default: index === selectedImageIndex,
    }));

    const data = {};
    data.MinimumPrice = 0;
    data.BannerIds = formData?.BannerIds;
    data.ProductName = formData?.ProductName;
    data.Keywords = `{${formData?.Keywords.map((k) => `"${k}"`).join(",")}}`;
    data.ProductDescription = formData?.ProductDescription;
    data.BrandName = formData?.BrandName;
    data.Mrp = formData?.Mrp;
    data.Default = false;
    data.DealPrice =
      formData?.IsProductInOffer == "bid" ? "0" : formData?.DealPrice;
    data.isPublish = true;
    data.IsProductInOffer =
      formData?.IsProductInOffer == "bid"
        ? true
        : formData?.IsProductInOffer == "buy"
        ? false
        : formData?.IsProductInOffer == "contact"
        ? null
        : null;
    data.Quantity = formData?.Quantity;
    data.EntryDate = new Date();
    data.PublishDate = null;
    data.FromPublishDate = formData?.FromPublishDate;
    data.ToPushlishDate = formData?.ProductExpiringTime;
    data.DealPriceDeclareDate = formData?.ProductExpiringTime;
    data.ProductExpiringTime = formData?.ProductExpiringTime;
    data.ImageUrl = updatedImageUrlArray;
    data.isDataIsAvailable = true;
    data.WinnerDeclareDayonEveryWeek = formData?.ProductExpiringTime;
    data.OfferPoints = formData?.RecommendedBid ? formData?.RecommendedBid : 0;
    data.ReLaunch = false;
    data.AutoRelaunch = false;
    data.RecommendedBid = formData?.RecommendedBid
      ? formData?.RecommendedBid
      : null;
    data.BidAmount = null;
    data.IsRelauchForPreviousUsers = null;
    data.DeliveryCharges = formData?.DeliveryCharges;
    data.DeliveryChargesId = null;
    data.CategoryId = formData?.CategoryId;

    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Product/AddAccordingToBanner`,
    };
    axios(options)
      .then((e) => {
        setFormData({
          BannerIds: "",
          ProductName: "",
          Mrp: "",
          DealPrice: "",
          BrandName: "",
          EntryDate: "",
          FromPublishDate: "",
          ToPublishDate: "",
          ProductExpiringTime: "",
          Quantity: "",
          IsProductInOffer: "",
          ProductDescription: "",
          Keywords: [],
          RecommendedBid: "",
          DeliveryCharges: "",
          CategoryId: "",
        });
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        setLoading("");
        document.getElementById("inputFile1").value = "";

        setImages([]);
        GetVendorProduct();
      })
      .catch((error) => {});
  };
  const handleUpdateProduct = () => {
    if (!editValidations()) return;
    setLoading("update");

    if (editImages) {
      const croppedImages = cropperRefs.current.map((cropper) => {
        if (cropper && cropper.getCroppedCanvas) {
          return cropper.getCroppedCanvas().toDataURL("image/jpeg");
        }
        return null;
      });

      // 📌 Keep updatedImageUrlArray as a local variable here
      const updatedImageUrlArray = croppedImages.map((croppedImage, index) => ({
        Images: croppedImage.replace(/^data:image\/[a-zA-Z]+;base64,/, ""),
        Default: index === selectedEditImageIndex,
        IsDelete: false,
        IsNewImageAdded: true,
      }));

      const sanitizedOldImages = oldImages?.map(({ Id, ...rest }) => rest);
      const joinAllImages = [...sanitizedOldImages, ...updatedImageUrlArray];
      console.log(joinAllImages,'joinAllImages')
      const removeId = joinAllImages.map(({ id, ...rest }) => rest);

      const data = {
        Id: editData?.Id,
        ImageUrl: removeId,
      };

      const options = {
        method: "POST",
        headers: {
          accept: "*/*",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loginToken || " "}`,
        },
        data: JSON.stringify(data),
        url: `${Apiurl()}/api/Product/SaveDeleteProductImage`,
      };

      axios(options)
        .then((e) => {
          setOldImages([]);
          setEditImages([]);
          setEditModal(false);
          GetVendorProduct();

          // ✅ Clear local image refs after API success
          cropperRefs.current = [];
        })
        .catch((error) => {
          console.error("Image update failed", error);
        });
    }

 

    const croppedImages = cropperRefs.current.map((cropper) => {
      if (cropper && cropper.getCroppedCanvas) {
        return cropper.getCroppedCanvas().toDataURL("image/jpeg"); // Get cropped data as base64
      }
      return null;
    });

    // Update the ImageUrl array
    const updatedImageUrlArray = croppedImages?.map((croppedImage, index) => ({
      Images: croppedImage?.replace(/^data:image\/[a-zA-Z]+;base64,/, ""),
      Name: null,
      ImgList: null,
      Default: index === selectedEditImageIndex,
    }));

    const data = {};
    data.Id = editData?.Id;
    data.MinimumPrice = 0;
    data.BannerIds = editData?.BannerIds;
    data.ProductName = editData?.ProductName;
    data.ProductDescription = editData?.ProductDescription;
    data.Keywords = `{${editData?.Keywords?.map((k) => `"${k}"`).join(",")}}`;
    data.BrandName = editData?.BrandName;
    data.Mrp = editData?.Mrp;
    data.Default = false;
    data.DealPrice =
      editData?.IsProductInOffer == "bid" ? "0" : editData?.DealPrice;
    data.isPublish = editData?.IsPublish;
    data.IsProductInOffer =
      editData?.IsProductInOffer == "bid"
        ? true
        : editData?.IsProductInOffer == "buy"
        ? false
        : editData?.IsProductInOffer == "contact"
        ? null
        : null;
    data.Quantity = editData?.Quantity;
    data.EntryDate = new Date();
    data.PublishDate = null;
    data.FromPublishDate = editData?.FromPublishDate;
    data.ToPushlishDate = editData?.ProductExpiringTime;
    data.DealPriceDeclareDate = editData?.ProductExpiringTime;
    data.ProductExpiringTime = editData?.ProductExpiringTime;
    data.ImageUrl = updatedImageUrlArray?.length ? updatedImageUrlArray : null;
    // data.Images = editData?.Images;
    data.isDataIsAvailable = true;
    data.WinnerDeclareDayonEveryWeek = editData?.ProductExpiringTime;
    data.OfferPoints = editData?.RecommendedBid ? editData?.RecommendedBid : 0;
    data.ReLaunch = false;
    data.AutoRelaunch = false;
    data.RecommendedBid = editData?.RecommendedBid
      ? editData?.RecommendedBid
      : null;
    data.BidAmount = null;
    data.IsRelauchForPreviousUsers = null;
    data.DeliveryCharges = editData?.DeliveryCharges;
    data.DeliveryChargesId = null;

    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Product/ProductUpdate`,
    };
    axios(options)
      .then((e) => {
        cropperRefs.current = [];

        

        setFormData({
          BannerIds: "",
          ProductName: "",
          Mrp: "",
          DealPrice: "",
          BrandName: "",
          EntryDate: "",
          FromPublishDate: "",
          ToPublishDate: "",
          ProductExpiringTime: "",
          Quantity: "",
          IsProductInOffer: "",
          ProductDescription: "",
          Keywords: [],
          RecommendedBid: "",
          DeliveryCharges: "",
          CategoryId: "",
        });
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        setLoading("");

        setEditImages([]);
        setEditModal(false);
        GetVendorProduct();
      })
      .catch((error) => {});
  };
  const handleCloseEditModal = () => {
    setEditModal(false);
  };
  const handleCloseRelaunchModal = () => {
    setRelaunchModal(false);
  };

  const handleFilterTable = (e) => {
    const filter = vendorFilter?.filter((item) => {
      const input = e.toLowerCase().trim();
      const formattedEntryDate = moment(item?.EntryDate)
        .format("DD/MM/YYYY h:mm:ss a")
        .toLowerCase();
      const formattedFromDate = moment(item?.FromPublishDate)
        .format("DD/MM/YYYY h:mm:ss a")
        .toLowerCase();
      const formattedToDate = moment(item?.ToPushlishDate)
        .format("DD/MM/YYYY h:mm:ss a")
        .toLowerCase();

      return (
        item.ProductName.toLowerCase().includes(input) ||
        item.BrandName.toLowerCase().includes(input) ||
        item.ProductDescription.toLowerCase().includes(input) ||
        item.Mrp.toString().includes(e) ||
        item.DealPrice.toString().includes(e) ||
        item.Quantity.toString().includes(e) ||
        item.DeliveryCharges.toLowerCase().includes(input) ||
        formattedEntryDate.includes(input) ||
        formattedFromDate.includes(input) ||
        formattedToDate.includes(input)
      );
    });
    setVendorProduct(filter);
  };
  const handleCloseEditBannerModal = () => {
    setChangeBannerModal(false);
  };
  const handleUpdateBanner = () => {
    setLoading("updateBanner");

    const data = {};
    data.ProductId = changeData?.ProductId;
    data.BannerId = changeData?.BannerId;

    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Product/UpdateProductBannerId`,
    };
    axios(options)
      .then((e) => {
        handleCloseEditBannerModal();
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        setLoading("");
        GetVendorProduct();
      })
      .catch((error) => {});
  };
  const handleRelaunch = () => {
    const data = {};
    data.Id = relaunchData?.Id;
    data.MinimumPrice = 0;
    data.BannerIds = relaunchData?.BannerIds;
    data.ProductName = relaunchData?.ProductName;
    data.ProductDescription = relaunchData?.ProductDescription;
    data.Keywords = `{${relaunchData?.Keywords.map((k) => `"${k}"`).join(
      ","
    )}}`;
    data.BrandName = relaunchData?.BrandName;
    data.Mrp = relaunchData?.Mrp;
    data.Default = false;

    data.DealPrice =
      relaunchData?.IsProductInOffer == "bid" ? "0" : relaunchData?.DealPrice;
    data.isPublish = true;
    data.IsProductInOffer =
      relaunchData?.IsProductInOffer == "bid"
        ? true
        : relaunchData?.IsProductInOffer == "buy"
        ? false
        : relaunchData?.IsProductInOffer == "contact"
        ? null
        : null;
    data.Quantity = relaunchData?.Quantity;
    data.EntryDate = new Date();
    data.PublishDate = null;
    data.FromPublishDate = relaunchData?.FromPublishDate;
    data.ToPushlishDate = relaunchData?.ProductExpiringTime;
    data.DealPriceDeclareDate = relaunchData?.ProductExpiringTime;
    data.ProductExpiringTime = relaunchData?.ProductExpiringTime;
    data.isDataIsAvailable = true;
    data.WinnerDeclareDayonEveryWeek = relaunchData?.ProductExpiringTime;
    data.OfferPoints = relaunchData?.RecommendedBid
      ? relaunchData?.RecommendedBid
      : 0;
    data.ReLaunch = false;
    data.AutoRelaunch = false;
    data.RecommendedBid = relaunchData?.RecommendedBid
      ? relaunchData?.RecommendedBid
      : null;
    data.BidAmount = null;
    data.IsRelauchForPreviousUsers = relaunchData?.IsRelauchForPreviousUsers;
    data.DeliveryCharges = relaunchData?.DeliveryCharges;
    data.DeliveryChargesId = null;

    const options = {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: JSON.stringify(data),
      url: `${Apiurl()}/api/Product/ReLaunchProduct`,
    };
    axios(options)
      .then((e) => {
        setRelaunchData({
          BannerIds: "",
          ProductName: "",
          ProductDescription: "",
          Keywords: [],
          RecommendedBid: "",
          Mrp: "",
          BrandName: "",
          IsProductInOffer: "",
          IsRelauchForPreviousUsers: "",
          DealPrice: "",
          Quantity: "",
          RecommendedBid: "",
          FromPublishDate: "",
          ToPublishDate: "",
          ProductExpiringTime: "",
        });
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        handleCloseRelaunchModal();
        GetVendorProduct();
      })
      .catch((error) => {});
  };

  const handleClose = () => {
    setPickupLocationModal(false);
  };

  const validateAddress = () => {
    const errors = {};
    const phonePattern = /^\d{10}$/;
    const pincodePattern = /^\d{6}$/;

    if (!address?.phoneNumber) {
      errors.phoneNumber = "Phone number is required";
    }
    if (!address?.phoneNumber.match(phonePattern)) {
      errors.phoneNumber = "Please enter a valid phone number";
    }
    if (!address?.pinCode) {
      errors.pinCode = "Pincode is required";
    }
    if (!address?.pinCode.match(pincodePattern)) {
      errors.pinCode = "Please enter a valid pincode";
    }
    if (!address?.areaAndStreet || address?.areaAndStreet?.trim() === "") {
      errors.areaAndStreet = "Address is required";
    }
    if (!address?.locality || address?.locality?.trim() === "") {
      errors.locality = "Locality is required";
    }
    if (!address?.city || address?.city?.trim() === "") {
      errors.city = "City is required";
    }
    if (!address?.state || address?.state?.trim() === "") {
      errors.state = "State is required";
    }

    // If there are errors, set them and return false
    if (Object.keys(errors).length > 0) {
      setErrorMessagePickup(errors);
      return false;
    }

    // If no errors, clear the error messages and return true
    setErrorMessagePickup({
      locality: "",
      areaAndStreet: "",
      city: "",
      state: "",
      landmark: "",
      phoneNumber: "",
      pinCode: "",
    });
    return true;
  };

  const handleSubmit = () => {
    if (!validateAddress()) return;
    const data = {
      locality: address?.locality,
      areaAndStreet: address?.areaAndStreet,
      city: address?.city,
      state: address?.state,
      landmark: address?.landmark,
      phoneNumber: address?.phoneNumber,
      pinCode: address?.pinCode,
      // userId:
    };

    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${FetchToken ? FetchToken : ""}`,
      },
      data: data,
      url: `${Apiurl()}/api/Vendor/SavePickUpLocation`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
          setPickupLocationModal(false);

          GetPickupLocation();
          setAddress({
            locality: "",
            areaAndStreet: "",
            city: "",
            state: "",
            landmark: "",
            phoneNumber: "",
            pinCode: "",
          });
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
      })
      .catch((error) => {});
  };
  const totalPages = Math.ceil(totalRecord / (numberOfRecordSelected || 10));
  const handleNextPage = () => {
    if (pageNumber < totalPages - 1) {
      GetVendorProduct(pageNumber + 1, "pag");
    }
  };

  const handlePrevPage = () => {
    if (pageNumber > 0) {
      GetVendorProduct(pageNumber - 1, "pag");
    }
  };

  const [pageIndex, setpageIndex] = useState(1);
  const [pageArray, setpageArray] = useState();
  const [totalRec, settotalRec] = useState();
  const [showingFrom, setshowingFrom] = useState(1);
  const [showingTo, setshowingTo] = useState(10);
  const changePage = (item) => {
    if (item === "...") {
      return;
    }
    setpageIndex(item);
    GetVendorProduct(item, "pag");
  };
  const prevPage = () => {
    if (pageIndex === 1) {
      return;
    }
    setpageIndex(pageIndex - 1);
    GetVendorProduct(pageIndex - 1, "pag");
  };
  const nextPage = () => {
    if (pageIndex === totalPages) {
      return;
    }
    setpageIndex(pageIndex + 1);
    GetVendorProduct(pageIndex + 1, "pag");
  };
  const pagination = () => {
    var current = pageIndex,
      last = totalPages,
      delta = 2,
      left = current - delta,
      right = current + delta + 1,
      range = [],
      rangeWithDots = [],
      l;
    for (let i = 1; i <= last; i++) {
      if (i == 1 || i == last || (i >= left && i < right)) {
        range.push(i);
      }
    }
    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push("...");
        }
      }
      rangeWithDots.push(i);
      l = i;
    }
    setpageArray(rangeWithDots);
  };
  useEffect(() => {
    pagination();
  }, [totalPages, pageIndex]);

  useEffect(() => {
    if (totalRecord == 0) {
      setshowingFrom(0);
      setshowingTo(0);
      return;
    }
    if (totalRecord <= Number(numberOfRecordSelected)) {
      setshowingFrom(1);
      setshowingTo(totalRecord);
      return;
    }
    setshowingTo(pageIndex * numberOfRecordSelected);
    setshowingFrom(
      pageIndex * numberOfRecordSelected - (numberOfRecordSelected - 1)
    );
    if (pageIndex * numberOfRecordSelected >= totalRecord) {
      setshowingTo(totalRecord);
    }
  }, [pageIndex, numberOfRecordSelected, totalRecord]);
  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      {loading === "vendor" ? (
        <div className="loading-container">
          <Loader />
        </div>
      ) : null}
      <Header setLoginToken={setLoginToken} />
      <UploadAndListingComponent
        bannerDataImage={bannerDataImage}
        formData={formData}
        setFormData={setFormData}
        setSelectedImageIndex={setSelectedImageIndex}
        setSelectedEditImageIndex={setSelectedEditImageIndex}
        selectedImageIndex={selectedImageIndex}
        selectedEditImageIndex={selectedEditImageIndex}
        handleImageUpload={handleImageUpload}
        handleEditImageUpload={handleEditImageUpload}
        handleCropAndSave={handleCropAndSave}
        images={images}
        editImages={editImages}
        cropperRefs={cropperRefs}
        vendorProduct={vendorProduct}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
        setEditModal={setEditModal}
        setEditData={setEditData}
        editModal={editModal}
        editData={editData}
        handleCloseEditModal={handleCloseEditModal}
        setEditErrorMessage={setEditErrorMessage}
        editErrorMessage={editErrorMessage}
        handleUpdateProduct={handleUpdateProduct}
        loading={loading}
        deliveryCharge={deliveryCharge}
        setCroppedImages={setCroppedImages}
        handleFilterTable={handleFilterTable}
        setChangeBannerModal={setChangeBannerModal}
        changeBannerModal={changeBannerModal}
        handleCloseEditBannerModal={handleCloseEditBannerModal}
        setChangeData={setChangeData}
        changeData={changeData}
        handleUpdateBanner={handleUpdateBanner}
        relaunchModal={relaunchModal}
        setRelaunchModal={setRelaunchModal}
        handleCloseRelaunchModal={handleCloseRelaunchModal}
        handleRelaunch={handleRelaunch}
        setRelaunchData={setRelaunchData}
        relaunchData={relaunchData}
        errorMessageRelaunch={errorMessageRelaunch}
        setErrorMessageRelaunch={setErrorMessageRelaunch}
        setPickupLocationModal={setPickupLocationModal}
        pickupLocationModal={pickupLocationModal}
        setAddress={setAddress}
        address={address}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        errorMessagePickup={errorMessagePickup}
        setErrorMessagePickup={setErrorMessagePickup}
        pickupLocationData={pickupLocationData}
        setEditImages={setEditImages}
        oldImages={oldImages}
        setOldImages={setOldImages}
        categoriesData={categoriesData}
        setNumberofRecordSelected={setNumberofRecordSelected}
        totalPages={totalPages}
        setpageIndex={setpageIndex}
        prevPage={prevPage}
        pageArray={pageArray}
        changePage={changePage}
        pageIndex={pageIndex}
        nextPage={nextPage}
        showingFrom={showingFrom}
        showingTo={showingTo}
        totalRecord={totalRecord}
        setPageNumber={setPageNumber}
        GetVendorProduct={GetVendorProduct}
      />
      <Footer />
    </div>
  );
};

export default VendorUploadProduct;
